/**
 * @desc 个人中心
 */
import styles from './index.scss';
import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import Permit from '../common/permit/Permit';

export default class PersonalIndex extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={styles.layout}>
                <div className={classNames('base-panel', styles.leftMenu)}>
                    <ul>
                        <li><Link activeClassName={styles.menuActive} to="/grzx/log">监管日志</Link></li>
                        <li><Link activeClassName={styles.menuActive} to="/grzx/report">历史报告</Link></li>
                        <li><Link activeClassName={styles.menuActive} to="/grzx/collect">我的收藏</Link></li>
                        <li><Link activeClassName={styles.menuActive} to="/grzx/pwd">密码修改</Link></li>
                    </ul>

                    <Permit uType="1">
                        <Link to="/admin" className="btn btn-gray">管理员界面</Link>
                    </Permit>
                </div>

                <div className={classNames('base-panel', styles.content)}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/personal/Index.jsx